/* eslint-disable */
import cx from 'classnames';
import moment from 'moment-timezone';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Link } from 'react-router';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete'
import FontAwesome from 'react-fontawesome';

import OzComponent from '../../lib/OzComponent';
import { usd, newOrder, isLoggedIn, ss, navTo, mapDispatch, distance, upperFirst, setToken, prettyHour, prettyDate, getParams } from '../../utils/util';
import './WhereField.css';


class WhereField extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  onSelect(address, placeId) {
    let where = {
      name: address,
      // lat: latLng.lat,
      // lng: latLng.lng,
    };
    this.setState(
      where,
      () => this.props.onSelect(where));
    return;

    // TODO: Once I fix Google maps quotas, return to pulling
    // geocoded address
    console.log('selected:', address);
    this.setState({ name: address });

    geocodeByAddress(address)
      .then(results => getLatLng(results[0]))
      .then(latLng => {
        let where = {
          name: address,
          lat: latLng.lat,
          lng: latLng.lng,
        };
        this.setState(
          where,
          () => this.props.onSelect(where));
      });
  }

  onChange(v) {
    let where = { name: v };
    this.setState(where)
    this.setState({ didType: true});
    this.props.onChange(where);
  }

  renderAutocompleteItem(item) {
    let fs = item.formattedSuggestion;
    return (
      <div className="location-ac-item">
        <strong>{fs.mainText}</strong>{' '}
        <small>{fs.secondaryText}</small>
      </div>
    );
  }

  where() {
    let geoIp = this.props.geoIp;
    let where = {};
    if (this.state.name == undefined) {
      where.name = this.props.prefill || '';
    } else {
      where.name = this.state.name;
      where.lat = this.state.lat;
      where.lng = this.state.lng;
    }
    return where;
  }

  select(e) {
    console.log('select', e.target);
    if (!this.state.didType) {
      this.setState({ name: '' });
    }
    // e.target.select();
    // // Mobile Safari
    // e.target.focus();
    // e.target.setSelectionRange(0,99999);
  }

  render() {
    let where = this.where();

    console.log('render with where:', where);

    return (
      <PlacesAutocomplete
        inputProps={{
                    value: where.name,
                    onChange: (v) => this.onChange(v),
                    onFocus: (e) => this.select(e),
                    placeholder: this.props.prefill || this.props.placeholder,
                    }}
        onSelect={(a, p) => this.onSelect(a, p)}
        autocompleteItem={this.renderAutocompleteItem}
        searchOptions={{ types: ['locality'] }}
        highlightFirstSuggestion={true}
      />
    );
  }
}

export default WhereField;



/** WEBPACK FOOTER **
 ** ./src/components/partials/WhereField.js
 **/